import { type FC, useCallback } from 'react';

import { deleteEntityAclsBulk } from '../../../ducks/common_acls/thunks';
import type { AclsContextItem } from '../../../panels/entity_acls/types';
import { getProfileIdFromAclsContextItem } from '../../../panels/entity_acls/utils';
import { useAppDispatch } from '../../../store/react_redux_typed';
import PromiseConfirmModal from '../../../ui/controls_modal/promise_confirm_modal/promise_confirm_modal';
import { formatObjectDefinitionLabel } from '../../../utils/object_type';
import withContextItems from '../context_items_hoc';
import type {
  ContextItemsHocProps,
  ModalComponentProps,
} from '../modals_manager/types';

type Props = ContextItemsHocProps<AclsContextItem> & ModalComponentProps;

const AclsDeleteFromContentModal: FC<Props> = (props) => {
  const { item } = props;
  const dispatch = useAppDispatch();

  const confirmAction = useCallback(
    () => () => {
      if (!item.aclsType || !item.aclsObjectId) {
        return Promise.resolve();
      }
      const profileId = getProfileIdFromAclsContextItem(item);
      if (!profileId) {
        return Promise.resolve();
      }
      return dispatch(
        deleteEntityAclsBulk(item.aclsType, item.aclsObjectId, profileId),
      );
    },
    [item],
  );

  if (!item?.aclsType) {
    return null;
  }

  const content = formatObjectDefinitionLabel(
    [{ object_type: item.aclsType, id: '' }],
    ({ objectName }) => ({
      single: `You are about to remove permissions from all the content in this ${objectName}. Do you want to continue?`,
      multiple: `You are about to remove permissions from all the content in these ${objectName}. Do you want to continue?`,
    }),
  );

  return (
    <PromiseConfirmModal
      {...props}
      id={item.id}
      headerText="Remove from Content"
      confirmButtonText="Remove"
      confirmAction={confirmAction}
      variant="danger"
    >
      {content}
    </PromiseConfirmModal>
  );
};

export default withContextItems(AclsDeleteFromContentModal);
